import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarClassificationConsultationList } from "../../../../../../../services/calendarClassificationConsultation.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.appointmentArrival.";

export const Classifications = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(calendarClassificationConsultationList);

  const [calendars, setCalendars] = useState<ISelectType[]>([]);

  const params = useMemo(
    () => ({
      EnableCode: true,
    }),
    [],
  );

  const fetchCalendarClassificationConsultationList = useCallback(async () => {
    const { data, success } = await sendRequest(params);
    if (data && success) {
      setCalendars(
        data.map((calendar) => ({
          id: calendar.identifier,
          name: calendar.name,
        })),
      );
    }
  }, [params, sendRequest]);

  useEffect(() => {
    fetchCalendarClassificationConsultationList();
  }, [fetchCalendarClassificationConsultationList]);

  return (
    <Grid item xs={12}>
      <AutoCompleteMulti
        name="classifications"
        options={calendars}
        label={t(translationPath + "classifications")}
        getOptionLabel={(option) => option.name}
        size="small"
        fullWidth
        keepOpenOnSelect
      />
    </Grid>
  );
});
